import React from 'react';
import propTypes from 'prop-types';
import { useState, useEffect } from 'react';

import EditItemModal from '../../../Modals/EditItemModal';
import { ModelPropType } from '../../../Model/ModelPropTypes';
import { useTranslation } from 'localization/useTranslation';

const ContentDialog = ({ model, title, isOpen, onSave, onCancel, editContent, updatedContent, draft }) => {
  const [content, setContent] = useState(null);
  const T = useTranslation();

  useEffect(() => {
    setContent(editContent);
  }, [editContent]);

  useEffect(() => {
    updatedContent(content);
  }, [content, updatedContent]);

  return (
    <>
      <EditItemModal
        isOpen={isOpen}
        title={title}
        saveText={T.common.ok}
        onSave={onSave}
        onCancel={onCancel}
        item={content}
        setItem={setContent}
        models={model}
        saveEnabled={draft}
      />
    </>
  );
};

ContentDialog.propTypes = {
  model: propTypes.arrayOf(ModelPropType).isRequired,
  title: propTypes.string.isRequired,
  isOpen: propTypes.bool.isRequired,
  onSave: propTypes.func,
  onCancel: propTypes.func,
  editContent: propTypes.object.isRequired,
  updatedContent: propTypes.func.isRequired
};

export default ContentDialog;
